import '../App.css';
// import useEffect
import { useEffect, useState } from 'react';
import {
    readFilesAndExtractURI,
    changeFileToJPG,
} from '../function/ImageConvertResizer';
import SendImages from '../components/SendImages';
import Banner from '../components/Banner';
import Loading from '../components/Loading';
import TitleComponent from '../components/TitleComponent';
import mainImage from '../assets/images/main-page.png';
import yes from '../assets/images/yes.png';
import no from '../assets/images/no.png';
import Footer from '../components/Footer';

function Main() {
    const [photos, setPhotos] = useState([]); // original images
    const [resizedImages, setResizedImages] = useState([]); // resized images without crop
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(0); // 0: concept, 1: upload, 2: info
    const [concept, setConcept] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const selectConcept = (selectedConcept) => {
        setConcept(selectedConcept);
        setState(1);
    };

    const onChange = async (e) => {
        let files = Array.from(e.target.files);

        if (files.length > 0 && files.length < 6) {
            setIsLoading(true);

            // image type 변환
            let jpegFiles = await Promise.all(
                files.map((file) => {
                    return changeFileToJPG(file);
                })
            );

            // 올린 사진들 width, height 중 작은 것을 512로 만들어 리사이징
            let resizedImageArray = await Promise.all(
                jpegFiles.map((file) => {
                    return readFilesAndExtractURI(file);
                })
            );

            setPhotos(resizedImageArray);
            setResizedImages(resizedImageArray);
            setIsLoading(false);
            setState(2);
        } else {
            alert('사진은 1~5장을 업로드하세요');
        }
    };

    const conceptSelectionDiv = () => {
        const concepts = [
            { key: 'studio', label: '스튜디오' },
            { key: 'job', label: '직업' },
            { key: 'season', label: '시즌' },
            { key: 'trip', label: '여행' },
            { key: 'water-paint', label: '수채화' },
            { key: 'oil-paint', label: '유화' },
        ];

        return (
            <>
                <div style={{ fontFamily: 'Suite-regular' }}>
                    <div
                        style={{
                            fontSize: '18px',
                            marginBottom: '20px',
                            textAlign: 'center',
                        }}
                    >
                        원하는 컨셉을 선택해주세요
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px',
                            alignItems: 'center',
                        }}
                    >
                        {concepts.map((c) => (
                            <button
                                key={c.key}
                                style={{
                                    width: '200px',
                                    padding: '15px',
                                    fontSize: '18px',
                                }}
                                onClick={() => selectConcept(c.key)}
                            >
                                {c.label}
                            </button>
                        ))}
                    </div>
                </div>
            </>
        );
    };

    const uploadBannerDiv = () => {
        return (
            <>
                <div>
                    <label htmlFor="upload-photos">
                        <div id="upload-button">+</div>
                    </label>
                    <input
                        id="upload-photos"
                        type="file"
                        multiple
                        onChange={onChange}
                        accept="image/x-png,image/jpeg,image/jpg,image/heic"
                    />
                </div>
            </>
        );
    };

    const resizedImagesDiv = () => {
        return (
            <>
                <div>
                    <SendImages
                        croppedImages={resizedImages}
                        showCropEdit={false}
                        showBreedSelection={false}
                        modelVersion="2"
                        concept={concept}
                    />
                </div>
            </>
        );
    };

    const subtitleDiv = () => {
        return (
            <>
                무엇을 만들고 싶나요?
                <br />
                강아지 혹은 고양이의 사진을 1 ~ 5장 업로드하세요
            </>
        );
    };

    const conceptInstructionDiv = () => {
        return (
            <>
                <div style={{ fontFamily: 'Suite-regular' }}>
                    <div style={{ fontSize: '18px' }}>
                        원하는 컨셉을 선택해주세요
                    </div>
                    <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                        <ul style={{ lineHeight: '180%' }}>
                            <li>스튜디오: 프로필 사진 같은 스튜디오 컨셉</li>
                            <li>직업: 다양한 직업 컨셉</li>
                            <li>시즌: 시즌별 테마 컨셉</li>
                            <li>여행: 여행지 테마 컨셉</li>
                        </ul>
                    </div>
                </div>
            </>
        );
    };

    const firstInstructionDiv = () => {
        return (
            <>
                <div style={{ fontFamily: 'Suite-regular' }}>
                    <div style={{ fontSize: '18px' }}>
                        같은 강아지 혹은 고양이의 사진을 1~5장 업로드하세요
                    </div>
                    <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                        <ul style={{ lineHeight: '180%' }}>
                            <li>
                                다양한 각도와 환경일수록 AI가 동물을 이해하는데
                                도움이 됩니다
                            </li>
                            <li>
                                동물이 중앙에 잘 위치하고 사물에 가려지지 않는
                                것이 좋아요
                            </li>
                        </ul>
                        <div
                            style={{ margin: '10px 0', paddingBottom: '20px' }}
                            className="instruction-images"
                        >
                            <div className="instruction-image">
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        color: '#658354',
                                        fontSize: '20px',
                                    }}
                                >
                                    YES 👍
                                </div>
                                <img src={yes} />
                            </div>
                            <div className="instruction-image">
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        color: '#cd071e',
                                        fontSize: '20px',
                                    }}
                                >
                                    NONO 👎
                                </div>
                                <img src={no} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const secondInstructionDiv = () => {
        return (
            <>
                <div style={{ fontFamily: 'Suite-regular' }}>
                    <div style={{ fontSize: '18px' }}>
                        <ol style={{ lineHeight: '180%' }}>
                            <li>생성할 아트 컬렉션의 이름을 정해주세요.</li>
                            <li>
                                실제{' '}
                                <strong style={{ fontFamily: 'Suite-bold' }}>
                                    사용하는 이메일
                                </strong>
                                을 입력해주세요. 아트 컬렉션의 진행상황과 결과를
                                이메일로 안내해드립니다.
                            </li>
                            <li>
                                동물이 강아지인지 고양이인지 선택해주세요. 그
                                외의 동물들은 아직 지원되지 않습니다.
                            </li>
                        </ol>
                    </div>
                </div>
            </>
        );
    };

    return (
        <div>
            {isLoading ? (
                <Loading />
            ) : (
                <div className="app ">
                    <div className="border-padding">
                        <TitleComponent subtitle={subtitleDiv()} />
                        <div className="page-content">
                            {state === 0 ? (
                                <Banner
                                    bannerTitle={'SELECT CONCEPT'}
                                    contentDiv={conceptSelectionDiv()}
                                />
                            ) : state === 1 ? (
                                <Banner
                                    bannerTitle={'UPLOAD IMAGE'}
                                    contentDiv={uploadBannerDiv()}
                                />
                            ) : state === 2 ? (
                                <Banner
                                    bannerTitle={'UPLOAD IMAGE'}
                                    contentDiv={resizedImagesDiv()}
                                />
                            ) : null}

                            {state === 0 ? (
                                <Banner
                                    contentDiv={conceptInstructionDiv()}
                                    bannerTitle={'RAYMONG 참고 사항'}
                                />
                            ) : state === 1 ? (
                                <Banner
                                    contentDiv={firstInstructionDiv()}
                                    bannerTitle={'RAYMONG 참고 사항'}
                                />
                            ) : state === 2 ? (
                                <Banner
                                    contentDiv={secondInstructionDiv()}
                                    bannerTitle={'RAYMONG 참고 사항'}
                                />
                            ) : null}
                        </div>
                    </div>

                    <Footer />
                </div>
            )}
        </div>
    );
}

export default Main;
